import React from 'react'
import ArchiveEventButton from 'organization/EventList/Cards/ArchiveEventButton'
import UnarchiveEventButton from 'organization/EventList/Cards/UnarchiveEventButton'
import {ListEventData} from 'organization/EventList'

export default function ArchiveEventButtons(props: {
  event: ListEventData
  setShowArchiveDialog: (show: boolean) => void
  setShowUnarchiveDialog: (show: boolean) => void
}) {
  const {event, setShowArchiveDialog, setShowUnarchiveDialog} = props

  if (event.is_archived) {
    return (
      <UnarchiveEventButton
        event={event}
        setShowUnarchiveDialog={setShowUnarchiveDialog}
      />
    )
  }

  return (
    <ArchiveEventButton
      event={event}
      setShowArchiveDialog={setShowArchiveDialog}
    />
  )
}
